import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsm from '../components/shared/InnerTabsm';
import { PlusIcon } from '../components/shared/Icons';
import FilterPeriodical from './FilterPeriodical';
import Extrawork from './Extrawork';
import NewRequestLeave from './NewRequestLeave';
import NewReplacement from './NewReplacement';
import NewPeriodical from './NewPeriodical';

const TABS = [
  {
    id: 'workflowadd',
    label: 'Add',
    
  },
  {
    id: 'workflowclientadd',
    label: 'Client',
    
  },
];

const WORKFLOW_INNER_ADD = [
  { id: 'leave', label: 'Leave', icon: <PlusIcon />, component: NewRequestLeave },
  { id: 'replacement', label: 'Replacement', icon: <PlusIcon />, component: NewReplacement },
  { id: 'extrawork', label: 'Extra Work', icon: <PlusIcon />, component: Extrawork },
];

const WORKFLOW_INNER_ADD_CLIENT = [
  { id: 'periodical', label: 'Periodical', icon: <PlusIcon />, component: NewPeriodical },
];




const FilterSuperAddUpdatePagem = () => {
  const [activeTab, setActiveTab] = useState('workflowadd');
  const { homeAccent } = useUser();

  return (
    <div className="fr-tab-page">
      <TabBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        homeRoute="/profile"
        homeColor={homeAccent}
      />
      <div className="fr-tab-content">
        {activeTab === 'workflowadd' && <InnerTabsm tabs={WORKFLOW_INNER_ADD} defaultId="leave"/>}
        {activeTab === 'workflowclientadd' && <InnerTabsm tabs={WORKFLOW_INNER_ADD_CLIENT} />}
      </div>
    </div>
  );
};

export default FilterSuperAddUpdatePagem;